import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { Popup, FormPlain, Field, Row, Button } from '@smartplatform/ui';
import { fio } from './tools';
import validateEmail from '../../../site/utils/validateEmail';
import store from '../../store';

@observer
export default class UserPopup extends React.Component {

	@observable user = null;
	@observable password = '';
	@observable passwordRepeat = '';
	@observable errors = [];
	
	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		if (this.props.userId) {
			try {
				this.user = await store.model.User.findById(this.props.userId);
			}
			catch (e) {
				console.error(e);
			}
		}
		else {
			this.user = new store.model.User();
			this.user.lastName = this.props.deputy.lastName;
			this.user.firstName = this.props.deputy.firstName;
			this.user.middleName = this.props.deputy.middleName;
			this.user.deputyId = this.props.deputy.id;
		}
	};
	
	onChangePassword = e => this.password = e.target.value;
	onChangePasswordRepeat = e => this.passwordRepeat = e.target.value;
	
	validate = async user => {
		this.errors = [];
		const { valid, message } = validateEmail(user.email || '');
		if (!valid) {
			this.errors.push(message);
		}
		else {
			const users = await store.model.User.find({
				where: { email: user.email }
			});
			if (users.length > 0 && user.id === null) this.errors.push('Такой E-mail уже зарегистрирован');
		}
		if (user.id) {
			if (this.password.length > 0 && this.passwordRepeat.length > 0 && this.password !== this.passwordRepeat) {
				this.errors.push('Пароли не совпадают');
			}
		}
		else {
			if (this.password.length === 0) {
				this.errors.push('Задайте пароль');
			}
			if (this.passwordRepeat.length === 0) {
				this.errors.push('Повторите пароль');
			}
			if (this.password.length > 0 && this.passwordRepeat.length > 0 && this.password !== this.passwordRepeat) {
				if (this.password !== this.passwordRepeat) {
					this.errors.push('Пароли не совпадают');
				}
			}
		}
	};
	
	beforeSave = async user => {
		await this.validate(user);
		console.log('errors', this.errors);
		if (this.errors.length === 0) {
			if (user.id) {
				if (this.password.length > 0) {
					user.password = this.password;
				}
				else {
					user.password = undefined;
				}
			}
			else {
				user.password = this.password;
			}
		}
		return this.errors.length === 0;
	};

	onSave = async user => {
		const { deputy, userId } = this.props;
		if (!userId) {
			deputy.userId = user.id;
			await deputy.save();
		}
		this.props.onClose && this.props.onClose(true);
	};
	
	render() {
		let content = '...';
		let header = <>{fio(this.props.deputy)} (user: {JSON.stringify(this.props.userId)})</>;
		
		if (this.user) {
			content = <>
				<FormPlain record={this.user} beforeSave={this.beforeSave} onSave={this.onSave}>
					<Row>
						<Field property="email" label="E-mail" isRequired={true} />
					</Row>
					<Row>
						<div className="form-field password">
							<label>Пароль:</label>
							<input
								type="password"
								autoComplete="new-password"
								value={this.password || ''}
								onChange={this.onChangePassword}
							/>
							<div className="password-hint">
								{this.user.id ? <>
									<i className="admin-icon-info-circled" />
									Оставьте поля пустыми, чтобы не менять пароль
								</> : <>&nbsp;</>}
							</div>
						</div>
						<div className="form-field">
							<label>Повторите пароль:</label>
							<input
								type="password"
								value={this.passwordRepeat || ''}
								onChange={this.onChangePasswordRepeat}
							/>
						</div>
					</Row>
				</FormPlain>
				{this.errors.length > 0 && <div className="error">{this.errors.join('. ')}</div>}
			</>;
		}
		
		return <Popup width={500} height={320} onClose={() => this.props.onClose(false)} header={header} scrollable={false}>
			{content}
		</Popup>;
	}
	
}
